import { defineMessages } from 'react-intl';

const messages = defineMessages({
  welcome_title: {
    id: 'gckRMt',
    defaultMessage: 'Introducing the FlashSystem Solution Finder',
  },
  welcome_message_1: {
    id: '/IAm6N',
    defaultMessage: 'Find the right FlashSystem tailored to your storage needs',
  },
  welcome_link: {
    id: 'I/tfmm',
    defaultMessage: 'Build Now',
  },

  // Assessment Modal Messages
  modal_header: {
    id: '2X4xIL',
    defaultMessage: 'IBM FlashSystem Solution Finder',
  },
  widget_title: {
    id: 'dPSEq0',
    defaultMessage: 'Solution Finder',
  },
  widget_object: {
    id: 'kGiP9z',
    defaultMessage: 'Solution Finder Page',
  },

  // Assessment Steps Messages
  modal_step_1: {
    id: 'P6TgSj',
    defaultMessage: 'Capacity Requirements',
  },
  modal_step_2: {
    id: 'tYCv/t',
    defaultMessage: 'Business Continuity & Cyber Security',
  },
  modal_step_3: {
    id: 'n8LckY',
    defaultMessage: 'Connectivity & Functionality',
  },
  modal_step_4: {
    id: 'rC5lTg',
    defaultMessage: 'Performance Considerations',
  },
  modal_step_5: {
    id: 'yaMHMB',
    defaultMessage: 'Results',
  },

  step_choose_option: {
    id: 'uiPiF8',
    defaultMessage: 'Choose an option',
  },
  step4_choose_option: {
    id: 'hRyIHC',
    defaultMessage: 'Select Options',
  },
  step_option_yes: {
    id: 'a5msuh',
    defaultMessage: 'Yes',
  },
  step_option_no: {
    id: 'oUWADl',
    defaultMessage: 'No',
  },
  step_recommendation: {
    id: 'OLkJH1',
    defaultMessage: 'Provide me with a recommendation',
  },

  //step1 content
  step1_para: {
    id: 'SfcOBw',
    defaultMessage:
      'Accurate capacity forecasting ensures the right storage and avoids bottlenecks. With your required capacity level, we can offer default functional recommendations, which you can refine later. To start, we just need your current capacity requirement. An estimate for future growth is optional but helpful.',
  },
  step1_accordion_title: {
    id: 'qHwj7M',
    defaultMessage: 'Please select your approximate capacity requirements',
  },
  step1_accordion_dd1: {
    id: '4zqma4',
    defaultMessage: 'What is your current capacity requirement?',
  },
  step1_accordion_dd2: {
    id: 'epbwTr',
    defaultMessage:
      'How much capacity will you require over the lifecycle of the solution? (Optional)',
  },
  step1_accordion_dd2_pdf: {
    id: 'o4P4Lr',
    defaultMessage:
      'How much capacity will you require over the lifecycle of the solution?',
  },
  step1_capacity: {
    id: '56DzI+',
    defaultMessage: 'Capacity',
  },
  step1_capacity_desc: {
    id: '1DtX0j',
    defaultMessage:
      'Your current capacity requirement is the only question for which we need a specific answer in order to propose a solution of the appropriate size.',
  },

  //step2 content
  step2_para: {
    id: 'cCgiYr',
    defaultMessage:
      'Ensure business continuity and cyber resilience with IBM FlashSystem—AI-driven threat detection helps minimize downtime and protect operations. Choose key features or let us provide you with a recommendation.',
  },
  step2_collapse_all: {
    id: 'bz6UVJ',
    defaultMessage: 'Collapse All',
  },
  step2_expand_all: {
    id: 'EgZZHp',
    defaultMessage: 'Expand All',
  },
  step2_accordion_title1: {
    id: 'o1wFDS',
    defaultMessage:
      'What elements of business continuity are important to you?',
  },
  step2_accordion_title2: {
    id: 'ERNwOY',
    defaultMessage: 'What elements of Cyber Resilience are important to you?',
  },
  step2_right_desclaim1: {
    id: 'j+Z2fq',
    defaultMessage:
      'IBM FlashSystem includes all of these features needed, free of charge.',
  },
  step2_right_desclaim2: {
    id: 'NYlOE1',
    defaultMessage:
      'These come at no extra cost on many of our configurations.',
  },
  step2_right_h1: {
    id: 'GGZxva',
    defaultMessage: 'Business Continuity & Cyber Resilience',
  },
  step2_right_h1_l1: {
    id: 'RWwXgl',
    defaultMessage:
      "Business continuity refers to an organization's ability to maintain essential functions during and after a disaster, ensuring personnel and assets are protected and able to function effectively.",
  },
  step2_right_h1_l2: {
    id: 'tG4X1q',
    defaultMessage:
      'Cyber resilience is the ability of an organization to maintain essential functions during and after a cyber attack.',
  },
  step2_right_h2: {
    id: 'LU2nvc',
    defaultMessage: 'Business Continuity',
  },
  step2_right_h2_l1: {
    id: 'zoxgDI',
    defaultMessage: 'Snapshots serve as point-in-time copies of your data.',
  },
  step2_right_h2_l2: {
    id: 'OULDUR',
    defaultMessage: 'Replication copies data to a remote system or cloud.',
  },
  step2_right_h2_l3: {
    id: 'GBZ3RJ',
    defaultMessage:
      'Snapshots and replication enable business recovery after failure.',
  },
  step2_right_h2_l4: {
    id: 'NZevAr',
    defaultMessage: 'HA setups reduce downtime for fast disaster recovery.',
  },
  step2_right_h2_l5: {
    id: 'uvpMT/',
    defaultMessage: 'Snapshot copies allow quick recovery after failure.',
  },
  step2_right_h3: {
    id: '/JgSsw',
    defaultMessage: 'Cyber Resilience',
  },
  step2_right_h3_l1: {
    id: 'X96Ux6',
    defaultMessage: 'Immutable copies are snapshots that cannot be altered.',
  },
  step2_right_h3_l2: {
    id: 'ukHjZl',
    defaultMessage:
      'In-line Threat Detection alerts you quickly to cyber threats.',
  },
  step2_right_h3_l3: {
    id: 'ld5fo5',
    defaultMessage: 'Air-gapped copies are isolated from network connections.',
  },
  step2_right_h3_l4: {
    id: 'k7x1qw',
    defaultMessage:
      'We can help you meet your industry and region’s regulations.',
  },
  step2_right_h3_l5: {
    id: 'TF3Fs4',
    defaultMessage: 'Cyber Recovery Guarantees are available for discussion.',
  },
  step2_business_opt_1: {
    id: 'wP4m1d',
    defaultMessage: 'Snapshot Management',
  },
  step2_business_opt_2: {
    id: 'Os7DzY',
    defaultMessage: 'Replication (Synch/Asynch)',
  },
  step2_business_opt_3: {
    id: 'qfPHK/',
    defaultMessage: 'Disaster Recovery (Dual Site)',
  },
  step2_business_opt_4: {
    id: 'IHZiu3',
    defaultMessage: 'High Availability (Dual Site Active/Active)',
  },
  step2_business_opt_5: {
    id: 'Pdzty9',
    defaultMessage: 'Backup and Recovery',
  },
  step2_cyber_opt_1: {
    id: '0yuuVu',
    defaultMessage: 'Immutable Copies',
  },
  step2_cyber_opt_2: {
    id: '5WsZx4',
    defaultMessage: 'In-line Threat Detection',
  },
  step2_cyber_opt_3: {
    id: '0lSATj',
    defaultMessage: 'Air-gapped copies',
  },
  step2_cyber_opt_4: {
    id: 'bvsF/Q',
    defaultMessage: 'Meeting Regulatory Requirements',
  },
  step2_cyber_opt_5: {
    id: 'xctynM',
    defaultMessage: '60 Second Cyber Recovery Guarentee',
  },

  //step3 content
  step3_para: {
    id: 'H3YKwU',
    defaultMessage:
      'Robust connectivity and advanced design make IBM FlashSystem fast, flexible, and efficient. Enjoy low latency, seamless integration, and smart data management. Pick your key features—or let us provide you with a recommendation.',
  },
  step3_accordion_title1: {
    id: '+4qygn',
    defaultMessage: 'Which connectivity options are important to you?',
  },
  step3_accordion_title2: {
    id: 'w9ShJt',
    defaultMessage: 'Which advanced functions are important to you?',
  },
  step3_right_desclaim1: {
    id: '97Jq8i',
    defaultMessage:
      'All prices include iSCSI/Fibre. NVMe support free on select systems.',
  },
  step3_right_desclaim2: {
    id: 'NYlOE1',
    defaultMessage:
      'These come at no extra cost on many of our configurations.',
  },
  step3_right_h1: {
    id: 'n8LckY',
    defaultMessage: 'Connectivity & Functionality',
  },
  step3_right_h1_l1: {
    id: 'q9qs7F',
    defaultMessage:
      'Choosing the right storage ensures fast connectivity and seamless data access. Advanced technologies boost performance, reduce latency, and ensure reliable integration. Streamlined management enhances efficiency.',
  },
  step3_right_h1_l2: {
    id: 'zVwgIO',
    defaultMessage:
      'Our systems deliver exceptional speed and efficiency through advanced designs. Data reduction technologies optimize capacity while enhancing cost-effectiveness. Robust security and seamless migration ensure flexibility and protection.',
  },
  step3_right_h2: {
    id: 'KZge6k',
    defaultMessage: 'Connectivity',
  },
  step3_right_h2_l1: {
    id: 'Z6xbGe',
    defaultMessage:
      'iSCSI enables fast data transport between hosts and storage.',
  },
  step3_right_h2_l2: {
    id: '1ADCfj',
    defaultMessage:
      'Fibre Channel ensures high-speed, reliable data transfers.',
  },
  step3_right_h2_l3: {
    id: '1UFP2m',
    defaultMessage:
      'NVMe unlocks significant performance beyond traditional interfaces.',
  },
  step3_right_h2_l4: {
    id: 'eri8ot',
    defaultMessage:
      'VMware integration is included, with expert guidance available.',
  },
  step3_right_h2_l5: {
    id: 'MOIXW5',
    defaultMessage: 'We support 3rd-party platform integration for your needs.',
  },
  step3_right_h3: {
    id: 'AMIMxX',
    defaultMessage: 'Advanced Functions',
  },
  step3_right_h3_l1: {
    id: '2xiOD8',
    defaultMessage:
      'All-flash systems deliver speed, scalability, and efficiency.',
  },
  step3_right_h3_l2: {
    id: 'lSfjsO',
    defaultMessage:
      'High-speed compression reduces storage size for more capacity.',
  },
  step3_right_h3_l3: {
    id: '+5X3n3',
    defaultMessage:
      'Data reduction optimizes capacity and eliminates duplicates.',
  },
  step3_right_h3_l4: {
    id: 'r95+xe',
    defaultMessage:
      'Encryption secures data, allowing access only to authorized users.',
  },
  step3_right_h3_l5: {
    id: '92Mw65',
    defaultMessage:
      'Transparent migration moves data efficiently between systems.',
  },
  step3_advanced_opt_1: {
    id: 'XFM4XV',
    defaultMessage: 'All Flash Technology',
  },
  step3_advanced_opt_2: {
    id: 'rlkQux',
    defaultMessage: 'Hardware Based Compression',
  },
  step3_advanced_opt_3: {
    id: 'DzFupo',
    defaultMessage: 'Software Based Data Reduction',
  },
  step3_advanced_opt_4: {
    id: 'htdmpO',
    defaultMessage: 'Encryption',
  },
  step3_advanced_opt_5: {
    id: 'tiH3kv',
    defaultMessage: 'Transparent Data Migration',
  },
  step3_connect_opt_1: {
    id: 'jWvmP5',
    defaultMessage: 'High speed iSCSI host support',
  },
  step3_connect_opt_2: {
    id: 'du5goX',
    defaultMessage: 'Fibre Channel host support',
  },
  step3_connect_opt_3: {
    id: 'Ncja4Y',
    defaultMessage: 'NVMe host support',
  },
  step3_connect_opt_4: {
    id: 'fImlO/',
    defaultMessage: 'VMWare Integration',
  },
  step3_connect_opt_5: {
    id: 'Igzo2+',
    defaultMessage: 'Management integration into 3rd party platforms',
  },

  //step4 content
  step4_para: {
    id: 'vj1vZ3',
    defaultMessage: `Host, VM, and snapshot counts impact storage performance and system choice. Efficient management prevents bottlenecks. If you're unsure, select "I don’t know" and we’ll provide you with a recommendation using industry standards.`,
  },
  step4_accordion_title1: {
    id: '1vtbP/',
    defaultMessage: 'Select host, VM and snapshot quantities',
  },
  step4_accordion_dd1: {
    id: 'WXDM28',
    defaultMessage: 'How many physical hosts do you have?',
  },
  step4_accordion_dd2: {
    id: 'pY3mDJ',
    defaultMessage: 'How many Virtual Machiness do have?',
  },
  step4_accordion_dd3: {
    id: 'wq/aEs',
    defaultMessage: 'How many local copies daily per host?',
  },
  step4_accordion_dd4: {
    id: '7WRRkC',
    defaultMessage: 'How many local copies daily per Virtual Machine?',
  },
  step4_right_h1: {
    id: 'rC5lTg',
    defaultMessage: 'Performance Considerations',
  },
  step4_right_desc: {
    id: 'iNV2OK',
    defaultMessage:
      'The considerations here impact system performance and the best model for your needs. If unsure, we can provide industry standard examples in our guideline.',
  },

  //step5 content
  step5_para: {
    id: 'jtbm1z',
    defaultMessage:
      "Based on your selections, we're excited to recommend this product from our catalog for you:",
  },
  step5_price: {
    id: '4BhSmV',
    defaultMessage: 'Current Total Price:',
  },
  step5_summary1: {
    id: 'HPGK2Z',
    defaultMessage:
      'Your downloadable report provides comprehensive details on configuration, guideline pricing where available, full specifications, advanced capabilities, and available purchasing options.',
  },
  step5_summary1_price: {
    id: '5u0wR5',
    defaultMessage:
      'Your downloadable report provides comprehensive details on configuration, guideline pricing, full specifications, advanced capabilities, and available purchasing options.',
  },
  step5_summary2: {
    id: 'O701KG',
    defaultMessage:
      'Our team of experts can refine further with you in due course.',
  },
  step5_summary3: {
    id: 'U4m1dr',
    defaultMessage:
      'Your full report can help you understand this and our team of experts can refine further with you in due course.',
  },

  //PDF content
  pdf_date_st: {
    id: '1O4fCf',
    defaultMessage: 'st',
  },
  pdf_date_nd: {
    id: 'sDM7IZ',
    defaultMessage: 'nd',
  },
  pdf_date_rd: {
    id: 'TYerAy',
    defaultMessage: 'rd',
  },
  pdf_date_th: {
    id: 'ToL0WD',
    defaultMessage: 'th',
  },
  pdf_page1_option1: {
    id: 'aid0zR',
    defaultMessage: 'Connectivity options',
  },
  pdf_page1_option2: {
    id: 'z3pQ/7',
    defaultMessage:
      'Advanced functions such as snapshot and data reduction technologies',
  },
  pdf_page1_option3: {
    id: '3PfQQF',
    defaultMessage: 'Performance considerations',
  },
  pdf_page1_option4: {
    id: '0Q4lvy',
    defaultMessage: 'Capacity requirements',
  },
  pdf_page1_option5: {
    id: 'y5iWuN',
    defaultMessage: 'Acquisition options',
  },
  pdf_page1_title: {
    id: 'v1DTt3',
    defaultMessage: 'IBM FlashSystem solution Finder',
  },
  pdf_page2_title: {
    id: '9uOFF3',
    defaultMessage: 'Overview',
  },
  pdf_page2_para1: {
    id: 'INyr1n',
    defaultMessage:
      'This report is based on input to the IBM FlashSystem Solution Finder online tool. Based on user input, this report provides a recommendation for an IBM FlashSystem configurtion suitable for your capacity requirements and your busines objectives.',
  },
  pdf_page2_para2: {
    id: 'M1ap5f',
    defaultMessage:
      'The detail in this report should not be taken as a final result for formal quotation and order. Rather, it should be used as a baseline guide in your conversation with our IBM technical team or the IBM Business Partner of your choice.',
  },
  pdf_page2_para3: {
    id: 'N1Xb45',
    defaultMessage:
      'The report will provide solution recommendations in the following areas:',
  },
  pdf_page2_para4: {
    id: 'EmxI0R',
    defaultMessage:
      'Our technical pre-sales team can discuss all of these elements with you.',
  },
  pdf_page2_btn1: {
    id: 'r4LLxj',
    defaultMessage: 'Contact IBM Technical Pre Sales',
  },
  pdf_page2_btn2: {
    id: 'XbVgWB',
    defaultMessage: 'All IBM FlashSystem Prices',
  },
  pdf_page3_title: {
    id: '2WWihC',
    defaultMessage: 'Your Results',
  },
  pdf_page3_price: {
    id: 'LbZK1v',
    defaultMessage: 'Recommended Price',
  },
  pdf_page3_price_no: {
    id: 'sTHOxy',
    defaultMessage: 'We will contact you with a price',
  },
  pdf_page3_para: {
    id: 'DjR15s',
    defaultMessage:
      'Guideline pricing is provided where available. Prices mentioned are IBM sample prices. Actual price may vary based on the IBM Business Partner’s pricing for the Products and the pricing established between the Distributor and the Reseller/Systems Integrator. IBM Business Partners are independent entities and are free to establish pricing and pricing terms at their sole discretion.',
  },
  pdf_page3_para_price: {
    id: 'ZfFPcW',
    defaultMessage:
      'Prices mentioned are IBM sample prices. Actual price may vary based on the IBM Business Partner’s pricing for the Products and the pricing established between the Distributor and the Reseller/Systems Integrator. IBM Business Partners are independent entities and are free to establish pricing and pricing terms at their sole discretion.',
  },
  pdf_page3_capacity_1: {
    id: '3ikngI',
    defaultMessage: 'Aprroximately {capacity} over the lifecycle',
  },
  pdf_page3_capacity_2: {
    id: 'W2X4Jr',
    defaultMessage:
      'The displayed capacity is our closest pre-built configuration as a price guideline.',
  },
  pdf_page3_capacity_3: {
    id: '6mEFRJ',
    defaultMessage:
      'Our Storage technical specialists can refine this requirement with you.',
  },
  pdf_page3_physical: {
    id: 'fMdONh',
    defaultMessage: 'Less than {hosts}',
  },
  pdf_page3_approx: {
    id: 'DHP/2O',
    defaultMessage: 'Approximately {approx}',
  },
  pdf_page4_title: {
    id: 'gfG15y',
    defaultMessage: 'Your Solution',
  },
  pdf_page4_title_opt10: {
    id: 'dtyp4j',
    defaultMessage: 'Other Benefits',
  },
  pdf_page4_para_opt10: {
    id: 'xJHu3i',
    defaultMessage: 'Performance Analytics & Capacity Planning',
  },
  pdf_page4_link_opt10: {
    id: '14P+1u',
    defaultMessage: 'Sustainability',
  },
  pdf_page4_title_opt11: {
    id: 'fc2p4B',
    defaultMessage: 'Consumption Model',
  },
  pdf_page4_para1_opt11: {
    id: 'SIqgKl',
    defaultMessage:
      'The displayed price is for an upfront purchase and includes 3 years 24 x 7 same business day coverage.',
  },
  pdf_page4_para2_opt11: {
    id: 'oex7lD',
    defaultMessage:
      'Financing is possible in many countries and our team will be happy to discuss with you.',
  },
  pdf_page4_para1_opt12: {
    id: 'ZAKnqM',
    defaultMessage:
      'Stay modern forever with flat, regular and transparent pricing.',
  },
  pdf_page4_para2_opt12: {
    id: 'PlGY0m',
    defaultMessage: 'Get new hardware if needed with performance SLA.',
  },
  pdf_page4_para3_opt12: {
    id: 'BpkcZb',
    defaultMessage:
      'Get new equipment if your device gets put on terminal SW or deemed EOS.',
  },
  pdf_page4_para4_opt12: {
    id: 'qHUMWW',
    defaultMessage:
      'Get new hardware if ever a capacity upgrade is unavailable for the system.',
  },
  pdf_page4_link_opt12: {
    id: 'mKkfuH',
    defaultMessage: 'More information',
  },

  pdf_page5_title: {
    id: '1/ETXZ',
    defaultMessage: 'IBM FlashSystem portfolio',
  },
  pdf_page5_h1: {
    id: '+OH+mj',
    defaultMessage: 'Get more in store',
  },
  pdf_page5_para1: {
    id: '1gU7TN',
    defaultMessage:
      'IBM FlashSystem® is a collection of high-speed, all-flash and hybrid flash storage solutions designed to streamline IT operations, support data modernization efforts and deliver unmatched value and price performance.',
  },
  pdf_page5_subTitle_1: {
    id: 'HQlC5W',
    defaultMessage: 'Move data smoothly',
  },
  pdf_page5_subTitle_1_p: {
    id: '3pmkWc',
    defaultMessage:
      'Deliver data where and when you need it with FlashSystem grid architecture by adapting to your business needs and eliminating unplanned outages. Data movements now have zero downtime and are non-disruptive, guaranteed. No swing box required.',
  },
  pdf_page5_subTitle_2: {
    id: '3bAXyO',
    defaultMessage: 'Optimize capacity',
  },
  pdf_page5_subTitle_2_p: {
    id: '4GBuon',
    defaultMessage:
      'Use AI-driven recommendations to optimize data placement for high performance or colder data use cases while unlocking 5.5 times more write cycles than industry-standard quad-level cell (QLC) solid-state drives (SSDs).',
  },
  pdf_page5_subTitle_3: {
    id: '/yc5oc',
    defaultMessage: 'Automate data management',
  },
  pdf_page5_subTitle_3_p: {
    id: 'P+Guih',
    defaultMessage:
      'Get at least 40% lifecycle cost savings with IBM FlashSystem by managing storage with artificial intelligence (AI) recommendations, business SLAs and policies as compared with competitive storage vendors using manual modeling.',
  },
  pdf_page5_subTitle_4: {
    id: 'vxmmes',
    defaultMessage: 'Safeguard consistently',
  },
  pdf_page5_subTitle_4_p: {
    id: 'XtFueA',
    defaultMessage:
      'Ensure data is safe with a resilient FlashSystem grid architecture based on immutable snapshots, flexible data replication features, real-time threat detection and autonomous response for quick recovery after cyberattacks to minimize impact.',
  },
  pdf_page5_subTitle_5: {
    id: 'Lb1O10',
    defaultMessage: 'Store data intelligent',
  },
  pdf_page5_subTitle_5_p: {
    id: 'dMCiBM',
    defaultMessage:
      'Optimize data centers with FlashCore Module computational storage, safeguarding and storing data without performance impact. IBM backs its Flash Core Modules (FCMs) with drive replacement under maintenance, guaranteed with no write limits.',
  },
  pdf_page5_subTitle_6: {
    id: 'vlXoDg',
    defaultMessage: 'Enhance energy efficiency',
  },
  pdf_page5_subTitle_6_p: {
    id: 'wB/7DE',
    defaultMessage:
      'Reduce energy consumption with a solid data storage sustainability guarantee. Some configurations guarantying as low as 1.7 W/TB.',
  },
  pdf_page6_subTitle_1: {
    id: 'CKVaUM',
    defaultMessage:
      'If you have a lower capacity workload, you may want to concider our FlashSystem 5300 Value Bundles as an alternative to the FlashSystem 5045.',
  },
  pdf_page6_subTitle_1_p: {
    id: 'Y5Iaoq',
    defaultMessage:
      'With our FlashSystem 5300 Value Bundles, you can access next-gen technology for a fraction of the price with bundles which are tailored to support smaller entry-capacity points with cost-effective alternatives.',
  },
  pdf_page6_subTitle_2: {
    id: 'sBwf21',
    defaultMessage:
      'If you have a high capacity workload, the FlashSystem C200 is optimized for your needs',
  },
  pdf_page6_subTitle_2_p1: {
    id: 'hnoLKz',
    defaultMessage:
      'IBM FlashSystem C200 is the latest addition to our FlashSystem family, delivering lower TCO and enterprise durability.',
  },
  pdf_page6_subTitle_2_p2: {
    id: 'pI7xmU',
    defaultMessage:
      'FlashSystem C200 extends our all-flash storage leadership to new workloads like media streaming, archives, and backups. Its balance of price, performance, and capacity can replace HDD storage with a reliable flash solution that can lower storage costs. FlashSystem C200 is backed by our FlashSystem guarantees, including energy efficiency, zero downtime, and ransomware detection. Drive replacements under maintenance are guaranteed, with 5.5x more write cycles than industry standard QLC drives.',
  },
  pdf_page6_subTitle_2_p2_btn: {
    id: '3Uj+jM',
    defaultMessage: 'More information including prices and configurations here',
  },
  pdf_page6_subTitle_2_p3: {
    id: 'sXmAiy',
    defaultMessage:
      'Learn more about Resilient Data Storage and schedule a meeting to learn more about the IBM FlashSystem Cyber Resiliency Guarantee. ',
  },
  pdf_page6_subTitle_2_p3_btn: {
    id: 'RK4FYl',
    defaultMessage: 'More Resilient Data Storage',
  },
  pdf_page7_title: {
    id: 'r2U6Fa',
    defaultMessage: 'Purchasing Options',
  },
  pdf_page7_para1: {
    id: 'Um/5Zm',
    defaultMessage:
      'Apart from an upfront acquisition, our team can discuss other purchasing options for your storage solution with you.',
  },
  pdf_page7_subTitle_1: {
    id: '6l+rKI',
    defaultMessage: 'IBM Storage Assurance',
  },
  pdf_page7_subTitle_1_p: {
    id: 'b81EDj',
    defaultMessage:
      'The IBM Storage Assurance program provides purchase protection that alleviates procurement obstacles and storage lifecycle management with a modern all flash platform engineered for non-disruptive innovation. IBM Storage Assurance is a subscription to hardware and software upgrades with premium support and quality of service across flexibile term limits.',
  },
  pdf_page7_subTitle_2: {
    id: 'vLfN11',
    defaultMessage: 'IBM Storage Utility',
  },
  pdf_page7_subTitle_2_p: {
    id: 'lctQz0',
    defaultMessage:
      'IBM Storage Utility enables you to procure storage your way, by paying for capacity only as you consume it. We identify your current and future needs and deploy the entire projected capacity on day-one giving you maximum performance for no disruptions during growth spurts.',
  },
  pdf_page7_subTitle_2_p2: {
    id: 'RjN8Cz',
    defaultMessage:
      'The choice is yours to pay for capacity as your business initiatives consume it.',
  },
  pdf_page7_subTitle_3: {
    id: 'mFbP6O',
    defaultMessage: 'IBM Storage as a Service',
  },
  pdf_page7_subTitle_3_p: {
    id: 'EL8bWs',
    defaultMessage:
      'IBM Storage as-a-Service can help you reduce IT spend by providing a cost-effective, scalable and reliable storage solution. Reduce the need for expensive hardware and software investments, cut maintenance costs and gain predictable pricing for your storage needs.',
  },
  pdf_page7_subTitle_4: {
    id: '9CGtNq',
    defaultMessage:
      'Our technical pre-sales team or the IBM Business Partner of your choice can disucss each of these options with you.',
  },
  pdf_page8_title: {
    id: 'QXiQEv',
    defaultMessage: 'Disclaimer',
  },

  //capacity options
  capacity_opt1: {
    id: '8bRGHQ',
    defaultMessage: '0 - 20TB',
  },
  capacity_opt2: {
    id: 'N5IMzZ',
    defaultMessage: '21 - 50TB',
  },
  capacity_opt3: {
    id: 'Eymt0A',
    defaultMessage: '51 - 100TB',
  },
  capacity_opt4: {
    id: 'itD3XC',
    defaultMessage: '101 - 200TB',
  },
  capacity_opt5: {
    id: 'fXmU50',
    defaultMessage: '201 - 500TB',
  },
  capacity_opt6: {
    id: 'CH2KeJ',
    defaultMessage: '501TB - 1PB',
  },
  capacity_opt7: {
    id: '6iofJ3',
    defaultMessage: '1PB +',
  },

  //connectivity options
  connectivity_opt1: {
    id: 'AkIyKO',
    defaultMessage: "I don't know",
  },
  connectivity_host_opt1: {
    id: 'S/TqTC',
    defaultMessage: '<5',
  },
  connectivity_host_opt2: {
    id: 'HkJ5tD',
    defaultMessage: '5 - 10',
  },
  connectivity_host_opt3: {
    id: '0roB6Y',
    defaultMessage: '11 - 15',
  },
  connectivity_host_opt4: {
    id: 'xXkHQi',
    defaultMessage: '16 - 25',
  },
  connectivity_host_opt5: {
    id: '2c3HN0',
    defaultMessage: '>25',
  },
  connectivity_vm_opt1: {
    id: 'MbygIJ',
    defaultMessage: '0',
  },
  connectivity_vm_opt2: {
    id: 'kcPIPz',
    defaultMessage: '1 - 50',
  },
  connectivity_vm_opt3: {
    id: '15gEIu',
    defaultMessage: '51 - 150',
  },
  connectivity_vm_opt4: {
    id: '74Msqx',
    defaultMessage: '151 - 300',
  },
  connectivity_vm_opt5: {
    id: 'vGsiFk',
    defaultMessage: '>300',
  },
  connectivity_copy_opt1: {
    id: 'EAzsgG',
    defaultMessage: '0 - 1',
  },
  connectivity_copy_opt2: {
    id: 'CmoBoM',
    defaultMessage: '2 - 4',
  },
  connectivity_copy_opt3: {
    id: 'jW8wfX',
    defaultMessage: '5 - 8',
  },
  connectivity_copy_opt4: {
    id: 'AWe/ZK',
    defaultMessage: '9 - 16',
  },
  connectivity_copy_opt5: {
    id: 'kDuVpo',
    defaultMessage: '>16',
  },
  connectivity_copyVM_opt1: {
    id: 'EAzsgG',
    defaultMessage: '0 - 1',
  },
  connectivity_copyVM_opt2: {
    id: '0on7U1',
    defaultMessage: '2 - 3',
  },
  connectivity_copyVM_opt3: {
    id: 'flnXyz',
    defaultMessage: '4 - 6',
  },
  connectivity_copyVM_opt4: {
    id: 'YYiFrK',
    defaultMessage: '7 - 12',
  },
  connectivity_copyVM_opt5: {
    id: '62gDL6',
    defaultMessage: '>12',
  },

  // button messages
  btn_download_pdf: {
    id: 'kQEvpX',
    defaultMessage: 'Download your full report',
  },
  btn_next: {
    id: '9+Ddtu',
    defaultMessage: 'Next',
  },
  btn_back: {
    id: 'cyR7Kh',
    defaultMessage: 'Back',
  },
  btn_close: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },

  // number messages
  number_1: {
    id: 'Tf9Oo0',
    defaultMessage: '1',
  },
  number_2: {
    id: 'QLJEES',
    defaultMessage: '2',
  },
  number_3: {
    id: 'O6+/CI',
    defaultMessage: '3',
  },
  number_4: {
    id: 'oyHYtA',
    defaultMessage: '4',
  },
  err_msg: {
    id: 'L/U/m9',
    defaultMessage:
      'oops, something went wrong while fetching the images for results.',
  },
});

export default messages;
